import { render } from "./WhatsAppMessagesStatistics.vue?vue&type=template&id=804778ea&scoped=true"
import script from "./WhatsAppMessagesStatistics.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessagesStatistics.vue?vue&type=script&lang=js"

import "./WhatsAppMessagesStatistics.vue?vue&type=style&index=0&id=804778ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804778ea"]])

export default __exports__